// Generated by CoffeeScript 2.7.0
var Page;

import Base from './base.js';

export default Page = (function() {
  class Page extends Base {};

  Page.prototype.availableLayouts = ['block'];

  return Page;

}).call(this);
